import { combineReducers } from 'redux';
import { appQrRelationsEntitiesReducer } from './app-qr-relations.entities';
import { appQrRelationsIdsReducer } from './app-qr-relations.ids';

export const appQrRelationsReducer = combineReducers({
  ids: appQrRelationsIdsReducer,
  entities: appQrRelationsEntitiesReducer,
});
